import { useState, useEffect } from 'react';
import { X, Download, Share } from 'lucide-react';

const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
const isInStandaloneMode = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    // Déjà installée → ne rien montrer
    if (isInStandaloneMode()) return;
    // Déjà dismissée
    if (sessionStorage.getItem('install-dismissed')) return;

    if (isIOS()) {
      setIos(true);
      setShow(true);
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShow(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const dismiss = () => {
    sessionStorage.setItem('install-dismissed', '1');
    setShow(false);
  };

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setShow(false);
    setDeferredPrompt(null);
  };

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed', bottom: '20px', left: '50%', transform: 'translateX(-50%)',
      width: 'calc(100% - 32px)', maxWidth: '420px',
      background: '#0d1b2e',
      border: '1px solid rgba(255,255,255,0.1)',
      borderRadius: '16px',
      padding: '14px 16px',
      display: 'flex', alignItems: 'center', gap: '12px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
      zIndex: 9999,
      fontFamily: "'Alan Sans', -apple-system, sans-serif",
    }}>
      <img src="/logo-transparent.png" alt="" style={{ width: '36px', height: '36px', objectFit: 'contain', flexShrink: 0 }} />

      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ margin: 0, fontSize: '13px', fontWeight: 700, color: '#fff' }}>
          Installer Wakaana Express
        </p>
        <p style={{ margin: '2px 0 0', fontSize: '12px', color: 'rgba(255,255,255,0.5)', lineHeight: 1.4 }}>
          {ios
            ? <>Appuyez sur <Share size={11} style={{ display:'inline', verticalAlign:'middle' }} /> puis <strong style={{color:'rgba(255,255,255,0.75)'}}>Sur l'écran d'accueil</strong></>
            : "Accès rapide depuis votre écran d'accueil"
          }
        </p>
      </div>

      {!ios && (
        <button onClick={install} style={{
          background: 'linear-gradient(135deg, #173b78, #2a66b8)',
          border: 'none', borderRadius: '10px',
          padding: '8px 14px', color: '#fff',
          fontSize: '12px', fontWeight: 700,
          cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px',
          flexShrink: 0, fontFamily: "'Alan Sans', sans-serif",
          whiteSpace: 'nowrap',
        }}>
          <Download size={13} /> Installer
        </button>
      )}

      <button onClick={dismiss} style={{
        background: 'none', border: 'none', cursor: 'pointer',
        color: 'rgba(255,255,255,0.4)', display: 'flex', padding: '4px', flexShrink: 0,
      }}>
        <X size={16} />
      </button>
    </div>
  );
}
